<!-- ===================================================================== -->
<!-- MODO CARROSSEL (default): imagem unica com setas + dots + contador.    -->
<!-- Mantido para nao quebrar os usos existentes.                          -->
<!-- ===================================================================== -->
<div *ngIf="!mostrarMiniaturas && !modoFaixa" class="iic-carrossel" (touchstart)="onTouchStart($event)" (touchend)="onTouchEnd($event)">
  <!-- Loading: skeleton com altura compativel (evita CLS) -->
  <p-skeleton *ngIf="loading && imagens.length === 0" width="100%" height="100%" styleClass="iic-skeleton">
  </p-skeleton>

  <!-- Placeholder: sem imagens (erro ou ausencia) -->
  <div *ngIf="!loading && imagens.length === 0" class="iic-placeholder">
    <i class="pi pi-image"></i>
  </div>

  <!-- Track de slides -->
  <div *ngIf="imagens.length > 0" class="iic-viewport">
    <div class="iic-track" [style.transform]="'translateX(-' + (indiceAtivo * 100) + '%)'">
      <div *ngFor="let url of imagens; let i = index" class="iic-slide">
        <!-- Lazy load real: so monta `src` do slide ativo e dos vizinhos imediatos -->
        <img *ngIf="deveCarregarSlide(i) && !urlComErro(url)"
          [src]="url" [alt]="textoAlt(i)" loading="lazy"
          (error)="onUrlErro(url)"
          [pTooltip]="tooltipAmpliar()" tooltipPosition="top"
          (click)="abrirLightbox()" (keydown.enter)="abrirLightbox()"
          tabindex="0" />
        <!-- Placeholder: slide fora da janela OU imagem com erro -->
        <div *ngIf="!deveCarregarSlide(i) || urlComErro(url)" class="iic-slide-placeholder" aria-hidden="true">
          <i class="pi pi-image"></i>
        </div>
      </div>
    </div>

    <!-- Setas (apenas com > 1 slide) -->
    <button *ngIf="imagens.length > 1" type="button" class="iic-seta iic-seta-prev"
      [disabled]="indiceAtivo === 0" (click)="anterior()" aria-label="Anterior">
      <i class="pi pi-chevron-left"></i>
    </button>
    <button *ngIf="imagens.length > 1" type="button" class="iic-seta iic-seta-next"
      [disabled]="indiceAtivo === imagens.length - 1" (click)="proximo()" aria-label="Proximo">
      <i class="pi pi-chevron-right"></i>
    </button>

    <!-- Contador -->
    <span *ngIf="imagens.length > 1" class="iic-contador">{{ textoIndicador() }}</span>

    <!-- Dots (indicadores) -->
    <div *ngIf="imagens.length > 1" class="iic-dots">
      <button *ngFor="let _ of imagens; let i = index" type="button"
        class="iic-dot" [class.active]="i === indiceAtivo"
        (click)="irPara(i)" [attr.aria-label]="textoAlt(i)"></button>
    </div>
  </div>
</div>

<!-- ===================================================================== -->
<!-- MODO MINIATURAS (e-commerce / MercadoLibre): coluna de thumbnails       -->
<!-- clicaveis + imagem principal ampliada ao lado.                          -->
<!-- ===================================================================== -->
<div *ngIf="mostrarMiniaturas && !modoFaixa" class="iic-galeria">
  <!-- Coluna/faixa de miniaturas (so aparece com > 1 imagem) -->
  <div *ngIf="imagens.length > 1" class="iic-thumbs" role="tablist">
    <button *ngFor="let url of imagens; let i = index" type="button"
      class="iic-thumb" [class.active]="i === indiceAtivo"
      role="tab" [attr.aria-selected]="i === indiceAtivo"
      [attr.aria-label]="textoAltMiniatura(i)"
      (click)="irPara(i)" (mouseenter)="irPara(i)">
      <img *ngIf="!urlComErro(url)" [src]="url" [alt]="textoAltMiniatura(i)" loading="lazy" (error)="onUrlErro(url)" />
      <div *ngIf="urlComErro(url)" class="iic-thumb-placeholder"><i class="pi pi-image"></i></div>
    </button>
  </div>

  <!-- Imagem principal ampliada -->
  <div class="iic-principal" (touchstart)="onTouchStart($event)" (touchend)="onTouchEnd($event)">
    <!-- Loading: skeleton -->
    <p-skeleton *ngIf="loading && imagens.length === 0" width="100%" height="100%" styleClass="iic-skeleton">
    </p-skeleton>

    <!-- Placeholder: sem imagens -->
    <div *ngIf="!loading && imagens.length === 0" class="iic-placeholder">
      <i class="pi pi-image"></i>
    </div>

    <!-- Imagem ativa -->
    <img *ngIf="imagens.length > 0 && !urlComErro(imagens[indiceAtivo])"
      [src]="imagens[indiceAtivo]" [alt]="textoAlt(indiceAtivo)" loading="lazy"
      (error)="onUrlErro(imagens[indiceAtivo])"
      [pTooltip]="tooltipAmpliar()" tooltipPosition="top"
      (click)="abrirLightbox()" (keydown.enter)="abrirLightbox()"
      tabindex="0" />
    <!-- Placeholder quando a imagem ativa falha ao carregar -->
    <div *ngIf="imagens.length > 0 && urlComErro(imagens[indiceAtivo])" class="iic-placeholder">
      <i class="pi pi-image"></i>
    </div>

    <!-- Contador -->
    <span *ngIf="imagens.length > 1" class="iic-contador">{{ textoIndicador() }}</span>
  </div>
</div>

<!-- ===================================================================== -->
<!-- MODO FAIXA: todas as imagens lado a lado (faixa horizontal rolavel).    -->
<!-- ===================================================================== -->
<div *ngIf="modoFaixa" class="iic-faixa">
  <!-- Loading -->
  <p-skeleton *ngIf="loading && imagens.length === 0" width="100%" height="100%" styleClass="iic-skeleton">
  </p-skeleton>

  <!-- Placeholder: sem imagens -->
  <div *ngIf="!loading && imagens.length === 0" class="iic-placeholder">
    <i class="pi pi-image"></i>
  </div>

  <!-- Todas as imagens lado a lado -->
  <button *ngFor="let url of imagens; let i = index" type="button" class="iic-faixa-item"
    [pTooltip]="tooltipAmpliar()" tooltipPosition="top"
    [attr.aria-label]="textoAlt(i)"
    (click)="abrirLightbox(i)" (keydown.enter)="abrirLightbox(i)">
    <img *ngIf="!urlComErro(url)" [src]="url" [alt]="textoAlt(i)" loading="lazy" (error)="onUrlErro(url)" />
    <div *ngIf="urlComErro(url)" class="iic-faixa-placeholder"><i class="pi pi-image"></i></div>
  </button>
</div>

<!-- Lightbox embutido -->
<div *ngIf="lightboxAberto" class="iic-lightbox-overlay" role="dialog" aria-modal="true"
  (click)="fecharLightbox()" (keydown.escape)="fecharLightbox()">
  <button type="button" class="iic-lightbox-close"
    [attr.aria-label]="tooltipAmpliar()"
    (click)="fecharLightbox(); $event.stopPropagation()">
    <i class="pi pi-times"></i>
  </button>
  <img *ngIf="lightboxUrl" [src]="lightboxUrl" [alt]="lightboxAlt"
    class="iic-lightbox-img" (click)="$event.stopPropagation()" />
</div>
